import React from 'react'

export default function Visita() {
  return (
    <div>
      Visita
    </div>
  )
}
